<!-- 缩略图 -->
<template>
    <div class="thumbnail-wrap">
        <!-- directive  -->
        <div v-viewer="options" class="img-box">
            <img v-for="(item, index) in imgList" :key="index" :src="item" :onerror="defaultImg" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Thumbnail',
        props: {
            id: {
                type: String | Number,
                default: ''
            }
        },
        data() {
            return {
                imgList: [],
                options: {
                    zIndex: 9000,
                    inline: false, // 启用内联模式
                    button: true, // 在查看器右上角显示按钮
                    navbar: false, // 指定导航栏的可见性
                    title: false, // 指定标题的可见性和内容
                    toolbar: true, // 指定工具栏及其按钮的可见性和布局
                    tooltip: true, // 放大或缩小时显示带有图像比率（百分比）的工具提示
                    movable: true, // 启用以移动图像
                    zoomable: true, // 启用以缩放图像
                    rotatable: false, // 启用以旋转图像
                    scalable: false, // 启用以翻转图像。
                    transition: false, // 为某些特殊元素启用CSS3转换
                    fullscreen: false, // 启用以在播放时请求全屏
                    keyboard: false, // 启用键盘支持。
                    url: 'src' // 定义获取原始图像URL以供查看的位置
                },
				defaultImg: 'this.src="' + require('../assets/img/default_pic.png') + '"'  // 默认封面
            }
        },
        watch: {
            id() {
                this._getTryImage();
            }
        },
        methods: {
            lookImgsFn(nowSrc) {
                this.$viewerApi({
                    images: this.imgList,
                    defaultOptions: {
                        url: nowSrc
                    }
                });
            },
            _getTryImage() {
                this.$fetch('/api/TryReading/GetTryImage', { id: this.id })
					.then((res) => {
						this.imgList = res.data;
					}).catch((err) => {
						throw err;
					});
            }
        }
    }
</script>

<style scoped>
    .thumbnail-wrap {
        width: 100%;
        padding-top: 20px;
    }

    .thumbnail-wrap .img-box {
        width: 100%;
        height: 200px;
        display: flex;
    }

    .thumbnail-wrap .img-box img {
        cursor: pointer;
        width: 19.2%;
        height: 100%;
        margin-right: 1%;
        border: 1px solid #DEE1E6;
    }

    .thumbnail-wrap .img-box img:last-child {
        margin-right: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/Thumbnail.vue